import config from "config/config";
import { canAccessAdminMenu } from "react-lib/apps/MeGen/common/megenPermissions";

export const SERVICE_PACKAGE_MENU = "Setting Package Lab";
export type ServicePackageAccessState = {
  adminMenuDivisions?: Record<string, unknown>;
  selectedDivision?: { id?: number | string };
  loginWithSocial?: boolean | string | null;
  divisionType?: string | null;
  showRequestOA?: { open?: boolean };
};
export const canCreateServicePackage = (controller?: {
  getState: () => ServicePackageAccessState;
  data: { division?: any; userProfile?: { is_superuser?: boolean } };
}): boolean => {
  if (!controller) return false;
  const state = controller.getState();
  return (
    !state.showRequestOA?.open &&
    state.divisionType !== "backoffice" &&
    !(config.V3_HIDDEN_TAB_LIST || []).includes(SERVICE_PACKAGE_MENU) &&
    canAccessAdminMenu(
      {
        ...state,
        selectedDivisionId: state.selectedDivision?.id ?? controller.data.division,
        isSuperUser: controller.data.userProfile?.is_superuser,
      },
      SERVICE_PACKAGE_MENU
    )
  );
};
